// @ts-nocheck
import { ButtonProps, default as MobiusButton } from "@insite/mobius/Button"; // eslint-disable-line
import uniqueId from "@insite/mobius/utilities/uniqueId";
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import {
    StyleguideCell,
    StyleguideCellInvert,
    StyleguideHead,
    StyleguideRow,
    StyleguideSection,
    StyleguideTable,
    StyleguideTableBody,
} from "@store/Library/Components/Toolkit/Styleguide/ui";
import {
    ButtonSizeVariant,
    ButtonVariant,
    MobiusButtonSizeVariant,
    MobiusButtonVariant,
} from "@toolkit/Framework/Types/Button";
import upperFirst from "lodash/upperFirst";
import React, { FC, useState } from "react";

interface ButtonVariantProps {
    variant: ButtonVariant;
}

interface ButtonVariantRowProps extends ButtonVariantProps {
    sizeVariant: ButtonSizeVariant;
}

interface ButtonIconProps extends ButtonProps {
    iconPosition: "right" | "left";
}

const Button: FC<ButtonProps> = props => <MobiusButton {...props}>Button</MobiusButton>;
const ButtonIcon: FC<ButtonIconProps> = ({ iconPosition, ...props }) => (
    <Button
        icon={{
            src: Upload,
            position: iconPosition,
        }}
        {...props}
    />
);

const ButtonVariantRow: FC<ButtonVariantRowProps> = props => {
    const variant = props.variant as MobiusButtonVariant;
    const sizeVariant = props.sizeVariant as MobiusButtonSizeVariant;

    return (
        <StyleguideRow>
            <StyleguideHead>{upperFirst(sizeVariant)}</StyleguideHead>
            <StyleguideCell>
                <Button variant={variant} sizeVariant={sizeVariant} />
            </StyleguideCell>
            <StyleguideCell>
                <Button variant={variant} sizeVariant={sizeVariant} disabled />
            </StyleguideCell>
            <StyleguideCell>
                <ButtonIcon variant={variant} sizeVariant={sizeVariant} iconPosition="left" />
            </StyleguideCell>
            <StyleguideCell>
                <ButtonIcon variant={variant} sizeVariant={sizeVariant} iconPosition="right" />
            </StyleguideCell>
            <StyleguideCellInvert>
                <Button variant={"inverted" as any} sizeVariant={sizeVariant} />
            </StyleguideCellInvert>
        </StyleguideRow>
    );
};

const ButtonVariant: FC<ButtonVariantProps> = ({ variant }) => {
    const [sectionId] = useState(`subsection-${uniqueId()}`);

    return (
        <StyleguideSection variant="h3" title={upperFirst(variant)} sectionId={sectionId} isSubSection>
            <StyleguideTable>
                <StyleguideTableBody>
                    <StyleguideRow>
                        <StyleguideHead></StyleguideHead>
                        <StyleguideHead>Normal</StyleguideHead>
                        <StyleguideHead>Disabled</StyleguideHead>
                        <StyleguideHead>Left Icon</StyleguideHead>
                        <StyleguideHead>Right Icon</StyleguideHead>
                        <StyleguideHead>Inverted</StyleguideHead>
                    </StyleguideRow>
                    <ButtonVariantRow variant={variant} sizeVariant="small" />
                    <ButtonVariantRow variant={variant} sizeVariant="medium" />
                    <ButtonVariantRow variant={variant} sizeVariant="large" />
                    <ButtonVariantRow variant={variant} sizeVariant="xlarge" />
                </StyleguideTableBody>
            </StyleguideTable>
        </StyleguideSection>
    );
};

const StyleguideButtons: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Buttons" sectionId={sectionId}>
            <ButtonVariant variant="primary" />
            <ButtonVariant variant="secondary" />
            <ButtonVariant variant="tertiary" />
        </StyleguideSection>
    );
};

export default StyleguideButtons;
